<template>
  <div class="fancy-feature-thirtyTwo pt-110 pb-160 md-pt-90 md-pb-100 home-solutions">
    <div class="container container-xl">
      <h2 class="home-solutions-heading">Our Solutions</h2>
      <h4 class="home-solutions-subheading">We offer a full spectrum of print services for your brand, ensuring your project is delivered with consistency, quality and care.</h4>
      <div class="row align-items-center justify-content-center">
        <div v-for="solution in content"
             :key="solution._id"
             class="col-lg-4 col-md-6"
             data-aos="fade-up"
             data-aos-duration="1200"
             :data-aos-delay="300">
          <div class="block-style-twentyTwo">
            <router-link :to="`our-solutions/${solution.slug.current}`"
                         class="solution__link">
              <div class="solution__card">
                <h3 class="solution__title">{{ solution.title }}</h3>
                <img :src="solution.icon.image.asset.url" alt="" class="solution__icon" />
                <div class="learn-more">
                  Learn more
                  <svg xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 640 640"
                       class="solution__caret">
                    <path d="M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z"/>
                  </svg>
                </div>
              </div>
              <div class="solution__services">
                <ul class="solution__services__list">
                  <li v-for="service in solution.services.slice(0,8)"
                      :key="service"
                      class="solution__service">
                    {{ service }}
                  </li>
                </ul>
                <div class="learn-more learn-more--white">
                  Learn more
                  <svg xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 640 640"
                       class="solution__caret">
                    <path d="M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z"/>
                  </svg>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="400">
        <a :href="`mailto:sales@marshallprint.co.uk?subject=Inquiry&body=---%0AContext: Home solutions block link`"
           class="btn btn-primary mt-100">
          Request a quote
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from '../../../sanity.js';
const query = `*[_type == "solution"]{
  _id,
  title,
  slug,
  icon {
    alt,
    image{
      asset->{
        url,
        metadata{
          dimensions{
            height,
            width
          }
        }
      }
    }
  },
  services[]
}`;
export default {
  name: 'SolutionsArea',
  data() {
    return {
      content: [],
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.error = this.home = null;
      this.loading = true;
      sanity.fetch(query).then(
          (content) => {
            this.loading = false;
            this.content = content;
          },
          (error) => {
            this.error = error;
          }
      );
    },
  }
}
</script>

<style lang="scss" scoped>
.home-solutions.fancy-feature-thirtyTwo {
  background-color: var(--darkblue);
  .home-solutions-heading {
    font-family: 'gilroy-light', sans-serif;
    color: var(--white);
    margin: 0 auto 3rem auto;
    text-align: center;
  }
  .home-solutions-subheading {
    color: var(--white);
    margin: 0 auto 2rem auto;
    max-width: 45rem;
    text-align: center;
  }
  .block-style-twentyTwo {
    border-radius: 0.25rem;
    @media (max-width: 991px) {
      padding: 0;
    }
    .solution__link {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      height: 23rem;
      justify-content: flex-start;
      position: relative;
      .learn-more {
        align-items: center;
        align-self: flex-end;
        display: flex;
        font-weight: bold;
        height: 1.5rem;
        justify-content: flex-end;
        margin-top: auto;
        padding: 0;
        position: relative;
        width: 9.5rem;
        &:after {
          display: none;
        }
        .solution__caret {
          fill: var(--pink);
          height: 2rem;
          width: 2rem;
          margin: 0 -0.5rem 0 0;
        }
      }
    }
    .solution__card {
      align-items: flex-start;
      background-color: var(--white);
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: flex-start;
      padding: 2rem;
      position: relative;
      transition: opacity 0.3s ease-in-out;
      width: 100%;
      z-index: 10;
      .solution__icon {
        bottom: 2rem;
        left: 3rem;
        height: auto;
        max-width: 5rem;
        position: absolute;
      }
      .solution__title {
        color: var(--pink);
        font-weight: bold;
        padding: 0 0 0.5rem 0;
        text-align: left;
      }
      &:hover {
        opacity: 0;
      }
    }
    .solution__services {
      align-items: flex-start;
      background-color: var(--pink);
      color: var(--darkblue);
      font-weight: bold;
      left: 0;
      padding: 2rem;
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      &__list {
        list-style: none;
        margin: 0;
        padding: 0;
        text-align: left;
        width: 100%;
      }
      .learn-more--white {
        color: var(--white);
        .solution__caret {
          fill: var(--white);
        }
      }
    }
    .solution__service {
      font-size: 1.15rem;
      line-height: 1.6rem;
      @media (max-width: 991px) {
        font-size: 1rem;
        line-height: 1.5rem;
      }
    }
  }
}
</style>
